/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {StreamBankMutableList} from "./StreamBankMutableList";
import React from "react";
import {service as EnvironmentalBenefitService} from '../../../Services/EnvironmentalBenefitService';
import {usePrimeCache} from "../../../Hooks/ServiceHooks";
import {useSortedData} from "../../../Hooks/ListHooks";


export const StreamBankProgramEnvBenefitsMutableList = (props) => {
    const { Data, sortKey } = props;
    const data = useSortedData(Data, sortKey);
    
    usePrimeCache([EnvironmentalBenefitService]);
    const environmentalBenefits = EnvironmentalBenefitService.CachedValues()?.result;
    
    return <StreamBankMutableList
        {...props}
        Editable={props.Editable && data?.length < Number(environmentalBenefits?.length)}
    />;
    
}
